module.exports = __webpack_public_path__ + "static/media/logo.cfb0d5ee.svg";